import { z } from 'zod';
import { currencyCodeSchema, nonNegativeNumberSchema } from './money';

export const exchangeRateSourceSchema = z.enum([
  'same_currency',
  'version_locked_rate',
  'version_unlocked_rate',
  'organization_rate',
  'fallback_one',
  'legacy_inverse_reset',
  'manual_edit',
  'unknown',
]);

export const exchangeRateRecordSchema = z.object({
  id: z.string().min(1).optional(),
  sourceCurrency: currencyCodeSchema,
  targetCurrency: currencyCodeSchema,
  baseCurrency: currencyCodeSchema.nullable().optional(),
  rate: nonNegativeNumberSchema,
  locked: z.boolean(),
  source: exchangeRateSourceSchema,
  sourceRef: z.string().min(1).nullable().optional(),
  validFrom: z.string().nullable().optional(),
  validTo: z.string().nullable().optional(),
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export const exchangeRateSetSchema = z.object({
  baseCurrency: currencyCodeSchema,
  rates: z.array(exchangeRateRecordSchema),
  allowFallbackOne: z.boolean(),
  preserveLegacyInverseResetBehavior: z.boolean(),
});

export type ExchangeRateSource = z.infer<typeof exchangeRateSourceSchema>;
export type ExchangeRateRecord = z.infer<typeof exchangeRateRecordSchema>;
export type ExchangeRateSet = z.infer<typeof exchangeRateSetSchema>;
